<template>
  <v-container class="ma-0 pa-0" style="width: 100vw" fluid>
    <v-row class="d-flex align-center justify-center pa-5 pb-12 ma-0" style="width: 100% !important; background-color: #111111">
      <div>
        <v-img class="justify-center my-5 mx-0" src="https://swiset.com/wp-content/uploads/2020/09/Swiset_Imagotipo_Full_RGB_White.svg" max-height="21px" contain/>
        <h1 style="color:#ffffff;" class="text-center">{{ getMasterTitle() }}</h1>
        <p style="color: #ffffff" class="text-center">{{ getMasterText() }}</p>
      </div>
    </v-row>
    <v-row align="center" justify="center" class="justify-center mt-n7 mx-0" style="width: 100%;">
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <iframe @click="facebookTrigger" style="border: 2px #00F784 solid; border-radius: 2%" width="100%" :height="(this.$store.state.desktop)? 350 : 228"
                src="https://www.youtube.com/embed/PX4bhjjItwk"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </v-col>
    </v-row>
    <v-row class="justify-center pa-5 mx-0 my-5" style="width: 100%;">
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <v-icon color="#00a553" class="d-flex justify-center mb-2" large>fa-trophy</v-icon>
        <h3 class="text-center" style="color: #00a553">{{ getAwardsTitle() }}</h3>
        <v-list style="background-color: rgb(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="award.number" v-for="award in awards">
            <h2 style="color: #00a553" :class="`mr-3 ml-${ (award.number === 1)? 0 : (award.number === 2)? 5 : 10}`"
                small>{{ award.number }}{{ award.suffix }}</h2>
            <h3 style="color: #111111" class="d-flex justify-start text-start">{{ award.text }}</h3>
          </v-list-item>
        </v-list>
        <v-divider v-if="!this.$store.state.desktop" class="my-5"/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <h3 class="text-center" style="color: #111111">{{ getRulesTitle() }}</h3>
        <v-list style="background-color: rgb(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="rule.number" v-for="rule in rules">
            <h4 color="black" class="mr-3">{{ rule.number }}</h4>
            <p class="d-flex justify-center text-start mb-n2">{{ rule.text }}</p>
          </v-list-item>
        </v-list>
        <v-divider v-if="!this.$store.state.desktop" class="my-5"/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <h3 class="text-center" style="color: #111111">{{ getStepsTitle() }}</h3>
        <p class="d-flex justify-center mt-2">{{ getSecondText() }}</p>
        <v-list style="background-color: rgb(0,0,0,0)">
          <v-list-item class="d-flex mt-n1" v-bind:key="step.icon" v-for="step in steps">
            <v-icon color="black" class="mr-3" small>{{ step.icon }}</v-icon>
            <p class="d-flex justify-center text-start mb-n2">{{ step.text }}</p>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row class="d-flex align-center justify-center pa-5 ma-0" style="width: 100% !important; background-color: #FFF75F">
      <div>
        <!--h2 style="color:#111111;" class="text-center">{{ getCTATitle() }}</h2!-->
        <v-btn style="color: #3a3a3a" class="swiset-button text-center" @click="scrollToRegister">{{ getCTAButtonText() }}</v-btn>
      </div>
    </v-row>
    <v-row class="d-flex align-center justify-center py-10 px-7 ma-0" style="background-color: #111111; width: 100%">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-icon color="#00F784" class="d-flex justify-center" large>fa-users</v-icon>
        <h3 style="color:#FFFFFF;" class="text-center my-3 px-12">{{ getSocialProofTitle() }}</h3>
        <p style="color: #F8F8F8" class="text-center mb-7">{{ getSocialProofText() }}</p>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <iframe @click="facebookTrigger" style="border: 2px #00F784 solid; border-radius: 2%" width="100%" :height="(this.$store.state.desktop)? 350 : 228"
                src="https://www.youtube.com/embed/0wtu0CzmRJc"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <iframe @click="facebookTrigger" style="border: 2px #00F784 solid; border-radius: 2%" width="100%" :height="(this.$store.state.desktop)? 350 : 228"
                src="https://www.youtube.com/embed/hF3ZaSIFcpo"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="12" lg="4" xl="4">
        <CollapsedRegister id="register" :language="language" :campaign="'B'"/>
      </v-col>
    </v-row>
    <v-img class="justify-center mt-5 mb-7" src="https://swiset.com/wp-content/uploads/2020/05/Swiset_Imagotipo_RGB_Black.svg" max-height="17px" contain/>
  </v-container>
</template>

<script>
import CollapsedRegister from "@/components/CollapsedRegister";
import { mapMutations } from 'vuex';
export default {
  name: "FundingCampaignB",
  components: {CollapsedRegister},
  data() {
    return {
      language: String,
      steps: [],
      rules: [],
      awards: [],

      // Parametrization
      masterTitle: '',
      masterText: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(['setDesktopContext']),
    init() {
      let desktop = screen.width >= 760;
      this.setDesktopContext(desktop);

      let lang = this.$route.query.lang;
      if (lang !== undefined)
        this.language = lang;
      else
        this.language = 'ES';

      this.setSteps();
      this.setAwards();
      this.setRules();

      window.fbq('track', 'Lead');
    },
    scrollToRegister() {
      let element = document.querySelector("#register");
      element.scrollIntoView({ behavior: 'smooth', block: 'end'});
    },

    // Parametrization
    getMasterTitle() {
      return (this.language === 'EN')? 'Futures Tournament!' : '¡Torneo de Futuros!';
    },
    getMasterText() {
      return (this.language === 'EN')? 'Yes. Funding examination for free with Swiset Pro.' : 'Reserva tu lugar para el torneo de futuros.';
    },
    getAwardsTitle() {
      return (this.language === 'EN')? 'Win one of the tournament rewards:' : 'Gánate uno de los premios del torneo:';
    },
    getStepsTitle() {
      return (this.language === 'EN')? 'Steps to participate:' : 'Pasos para participar:';
    },
    getRulesTitle() {
      return (this.language === 'EN')? 'Tournament rules:' : 'Reglas del torneo:';
    },
    getSecondText() {
      return (this.language === 'EN')? '3 simple steps to compete on our tournament:' : 'En 3 simples pasos podrás acceder a nuestro torneo:';
    },
    getCTATitle() {
      return (this.language === 'EN')? 'Join the tournament now' : 'Únete ahora al torneo';
    },
    getCTAButtonText() {
      return (this.language === 'EN')? 'Join the tournament now' : 'Únete ahora al torneo';
    },
    getSocialProofTitle() {
      return (this.language === 'EN')? 'Trusted by traders and academies in +28 countries' : 'Regístrate al torneo y ten un mes gratis de Swiset Pro';
    },
    getSocialProofText() {
      return (this.language === 'EN')? 'Listen our community reviews' : 'Plataforma líder en gestión de riesgos. Escucha opiniones.';
    },
    setAwards() {
      let awardsEN = [
        { number: 1, suffix: 'st', text: '75K USD Funding Exam' },
        { number: 2, suffix: 'nd', text: '50K USD Funding Exam' },
        { number: 3, suffix: 'rd', text: '25K USD Funding Exam' },
      ];
      let awardsES = [
        { number: 1, suffix: 'ro', text: 'Prueba de Fondeo 75K USD' },
        { number: 2, suffix: 'do', text: 'Prueba de Fondeo 50K USD' },
        { number: 3, suffix: 'ro', text: 'Prueba de Fondeo 25K USD' },
      ];
      this.awards = (this.language === 'EN')? awardsEN : awardsES;
    },
    setSteps() {
      let stepsEN = [
        { icon: 'fa-star', text: 'Be Swiset Pro user' },
        { icon: 'fa-check', text: 'Verify an account on Swiset' },
        { icon: 'fa-dollar-sign', text: 'Compete and get 1 of the 3 FREE funding examination' },
      ];
      let stepsES = [
        { icon: 'fa-star', text: 'Integrar tus cuentas de NinjaTrader' },
        { icon: 'fa-check', text: 'Verifica una de tus cuentas en Swiset' },
        { icon: 'fa-dollar-sign', text: 'Compite y obten 1 de nuestras 3 pruebas de fondeo.' },
      ];
      this.steps = (this.language === 'EN')? stepsEN : stepsES;
    },
    setRules() {
      let rulesEN = [
        { number: 1, text: 'Minimum 15 days of trading' },
        { number: 2, text: 'NinjaTrader 8 as plataform' },
        //{ number: 3, text: 'Any time is valid' },
        //{ number: 4, text: 'Folow @getswiset and @earn2trade_esp on IG' },
        { number: 3, text: 'Most winning trade cannot be greater than 30% total' },
      ];
      let rulesES = [
        { number: 1, text: 'Mínimo 15 días de operativa' },
        { number: 2, text: 'NinjaTrader 8 como plataforma' },
        //{ number: 3, text: 'Cualquier horario es válido' },
        //{ number: 4, text: 'Seguir a @getswiset y @earn2trade_esp en IG' },
        { number: 3, text: 'Operación más ganadora no puede representar +30% del total' },
      ];
      this.rules = (this.language === 'EN')? rulesEN : rulesES;
    },
    facebookTrigger() {
      window.fbq('track', 'ViewContent');
    },
  }
}
</script>

<style scoped>

</style>
